import React, { useEffect } from 'react';
import useHandleErrorFields from '../../../../hooks/useHandleErrorFields';
import InputButtonFile from '../../../../components/inputs/InputButtonFile';
import { LoadTicketHistoryDataForm } from '../../../../app/models/LoadTicketsHistory';

interface LoadTicketHistoryFormProps {
    loadTicketHistoryDataForm: LoadTicketHistoryDataForm;
    setLoadTicketHistoryDataForm: (loadTicketHistoryDataForm: LoadTicketHistoryDataForm) => void;
    errorFields?: any;
}

const LoadTicketHistoryForm = ({
    loadTicketHistoryDataForm,
    setLoadTicketHistoryDataForm,
    errorFields
}: LoadTicketHistoryFormProps) => {
    const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors } = useHandleErrorFields();

    useEffect(() => {
        setErrors(errorFields);
    }, [errorFields]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setLoadTicketHistoryDataForm({ ...loadTicketHistoryDataForm, [name]: value });
    };

    return (
        <>
            <div className="mb-2 row">
                <div className="col-md-12">
                    <label className="col-form-label">Comentario</label>
                    <textarea
                        className={`form-control ${fieldHasError('comment')}`}
                        name="comment"
                        id="comment"
                        value={loadTicketHistoryDataForm.comment}
                        onChange={handleChange}
                        placeholder="Ingrese un comentario"
                        onFocus={() => onFocusRemove('comment')}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('comment')}
                    </div>
                </div>
            </div>
        </>
    );
};

export default LoadTicketHistoryForm;
